import nl from "./nl.json";
import en from "./en.json";

window.messages = {
  en: en,
  nl: nl,
};
export default window.messages;
